import React from "react";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const BackdropLoader = ({ isOpen }) => {
	return (
		<Backdrop
			sx={{
				background: "#084170cc",
				zIndex: (theme) => theme.zIndex.drawer + 1,
			}}
			open={isOpen}
		>
			<CircularProgress />
		</Backdrop>
	);
};

export default BackdropLoader;
